import firebase from "js/firebase";
import { openWindowAndWaitForItToBeClosed } from "js/core/utilities/selfClosingWindow";

export class DropboxAuthError extends Error { }
export class DropboxAuthFlowWasInterruptedError extends DropboxAuthError { }

interface DropboxAuthTokens {
    accessToken: string
}

/**
 * Grants our app offline access for the given scope, executes the redirect ouath flow in a separate window
 * and saves the tokens
 */
export async function grantOfflineAccess(): Promise<DropboxAuthTokens> {
    const userIdToken = await firebase.auth().currentUser.getIdToken();

    const url = `${window.location.origin}/dropbox/auth` +
        `?continueUrl=${encodeURIComponent("/close")}` +
        `&userIdToken=${encodeURIComponent(userIdToken)}` +
        "&requestOfflineAccess=true";

    const lastSearchParams = await openWindowAndWaitForItToBeClosed(url);

    const accessToken = lastSearchParams.get("dropbox_access_token");
    const error = lastSearchParams.get("dropbox_auth_error");

    if (error) {
        throw new DropboxAuthError(error);
    }

    if (!accessToken && !error) {
        throw new DropboxAuthFlowWasInterruptedError();
    }

    return { accessToken };
}
